var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.7,
    height: 41.7,
    viewBox: "0 0 41.7 41.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 41.7,
    height: 41.7,
    rx: 10,
    ry: 10,
    fill: "#f3a25c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "_13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.75,32.49c-.28-.05-.56-.1-.82-.17-4.15-1.09-5.71-3.56-5.78-3.66-3.48-5.1,1.31-10.57,1.36-10.62l.31-.35.05.47c.39,3.55,3.57,4.42,3.71,4.46l-.1.4s-3.3-.9-3.95-4.34c-.96,1.27-3.82,5.66-1.03,9.75.02.03,1.56,2.44,5.53,3.49.24.06.51.12.78.16l-.07.41Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.59,32.18l.16-.38c.32-.75.45-1.5.39-2.24-.15-1.92-1.56-3.9-4.31-6.04,0,1.06-.17,3.7-1.55,4.18-1.21.42-2.31.02-3.29-1.2,0,.57.09,1.53.59,2.63l-.38.17c-.86-1.9-.6-3.36-.59-3.42l.09-.5.28.42c.95,1.39,2.01,1.9,3.15,1.5,1.18-.41,1.31-3.18,1.27-4.21l-.02-.44.35.27c3.07,2.32,4.64,4.48,4.81,6.6.05.68-.04,1.37-.27,2.06.07-.02.11-.03.11-.03,4.9-1.22,5.01-6.75,5.01-6.81-.09-3.99-2.41-5.8-3.36-6.38.25,1.03.73,3.4.1,4.3-.16.23-.39.36-.65.38-.06,0-.93-.04-1.87-1.08-1.26-1.39-2.65-4.62-2.25-12.08-1.3,1.1-5.61,5.14-5.38,9.9l-.42.02c-.15-3.04,1.47-5.75,2.85-7.49,1.49-1.87,2.99-3.02,3.06-3.07l.36-.27-.03.45c-.48,7.62.87,10.86,2.09,12.22.82.92,1.56.97,1.57.97.12-.01.23-.08.32-.2.56-.8-.01-3.46-.28-4.41l-.12-.42.4.17s3.91,1.7,4.02,6.97c0,.06-.11,5.93-5.31,7.22,0,0-.19.05-.51.13l-.4.1Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "m20.85,37.29c-9.07,0-16.44-7.38-16.44-16.44S11.79,4.41,20.85,4.41s16.44,7.38,16.44,16.44-7.38,16.44-16.44,16.44Zm0-32.46c-8.84,0-16.02,7.19-16.02,16.02s7.19,16.02,16.02,16.02,16.02-7.19,16.02-16.02S29.69,4.83,20.85,4.83Z",
    fill: "#fff",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.a88c0b74bb92c8cc0afc9f6bca919be3.svg";
export { ForwardRef as ReactComponent };